"use client";

import * as React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "@chotca/ui";

export function Providers({
  children,
  client,
}: {
  children: React.ReactNode;
  client?: QueryClient;
}) {
  const [defaultClient] = React.useState(
    () =>
      client ??
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            staleTime: 60_000,
            gcTime: 10 * 60_000,
            retry: 1,
          },
        },
      }),
  );
  return (
    <QueryClientProvider client={client ?? defaultClient}>
      <ToastProvider>{children}</ToastProvider>
    </QueryClientProvider>
  );
}
